import React, { useContext } from 'react'

import { Input, Modal, Form } from 'antd'

import GeneralContext from '../../context/GeneralContext/GeneralContext';
import api from '../../services/api'
import SL_Button from '../../components/buttons/Button';
import { MaskedInput } from 'antd-mask-input'
import SL_Date from '../../components/dates/Date';
import { displayMessage } from '../../services/helper';

const inputsClassName = `border-appian-blue max-h-9 text-base`

export default function CreateControl(props) {

    const {setShowLoading, windowHeight} = useContext(GeneralContext)

    const handleCreateControl = (values) => {
        setShowLoading(true)

        api.control.create(values)
            .then(
                rs => {
                    alert(displayMessage('CREATE_CONTROL_SUCCESS'), 'success', displayMessage('SUCCESS'))
                    props.refreshControls()
                }
            ).finally(
                () => {
                    setShowLoading(false)
                    props.handleOnCloseModal()
                }
            )
    }

    return (
        <Modal
            title={<div className="text-xl font-bold text-appian-blue">{displayMessage('CREATE_CONTROL')}</div>}
            visible={props.isModalVisible}
            onCancel={props.handleOnCloseModal}
            centered={true}
            footer={[]}
            width={750}
            style={{position: 'relative'}}
            bodyStyle={{ maxHeight: windowHeight*0.8, overflow: 'auto'}}
        >
            <Form
                className='w-full flex flex-col gap-2 p-5'
                onFinish={handleCreateControl}
                layout="vertical"
                requiredMark='optional'
            >
                <div className='font-bold text-lg text-appian-blue text-center'>
                    {displayMessage('CONTROL_DATA')}
                </div>

                <Form.Item
                    label={displayMessage('NAME')}
                    name="first_name"
                    className={`w-full flex`}
                    rules={[{ required: true, message: displayMessage('FULL_NAME_MANDATORY') }]}
                >
                    <Input
                        type="text"
                        size='large'
                        placeholder={displayMessage('NAME')}
                        className={inputsClassName}
                    />
                </Form.Item>
                <Form.Item
                    label={displayMessage('LAST_NAME')}
                    name="last_name"
                    className={`w-full flex`}
                    rules={[{ required: true, message: displayMessage('FULL_NAME_MANDATORY') }]}
                >
                    <Input
                        type="text"
                        size='large'
                        placeholder={displayMessage('LAST_NAME')}
                        className={inputsClassName}

                    />
                </Form.Item>
                <Form.Item
                    label={displayMessage('CPF')}
                    name="cpf"
                    className={`w-full flex`}
                    rules={[{ required: true, message: displayMessage('CPF') }]}
                >
                    <MaskedInput
                        type="text"
                        size='large'
                        placeholder={displayMessage('CPF')+displayMessage('CPF_EXEMPLE')}
                        className={inputsClassName}
                        mask={'000.000.000-00'}
                    />
                </Form.Item>
                <Form.Item
                    label={displayMessage('EMAIL')}
                    name="email"
                    className={`w-full flex`}
                    rules={[{ required: true, message: displayMessage('EMAIL'), type: "email", }]}
                >
                    <Input
                        type="email"
                        size='large'
                        placeholder={displayMessage('EMAIL')+displayMessage('EMAIL_EXEMPLE')}
                        className={inputsClassName}

                    />
                </Form.Item>
                <Form.Item
                    label={displayMessage('BIRTHDAY')}
                    name="birth_date"
                    className={`w-full flex`}
                    rules={[{ required: true, message: displayMessage('CPF') }]}
                >
                    <SL_Date 
                        className={inputsClassName}
                        style={{ width: '100%', height: 110}}
                        placeholder={displayMessage('SELECT_DATE')}
                        format={'DD/MM/YYYY'}
                    />
                </Form.Item>
                <Form.Item
                    label={displayMessage('IDENTIFICATOR_CONTROL')}
                    name="identificator_control"
                    className={`w-full flex`}
                    rules={[{ required: true, message: displayMessage('IDENTIFICATOR_CONTROL') }]}
                >
                    <Input
                        type="text"
                        size='large'
                        placeholder={displayMessage('IDENTIFICATOR_CONTROL')}
                        className={inputsClassName}

                    />
                </Form.Item>

                <SL_Button
                    type="primary"
                    size='large'
                    htmlType="submit"
                    className="border-appian-blue max-h-9 text-base w-full sticky bottom-[-20px]"
                >
                    {displayMessage('CREATE_CONTROL')}
                </SL_Button>
            </Form>
        </Modal >
    )
}